// RegistrationForm.js
import { useState } from 'react';
import { Steps, Row, Col, Divider, Form, message } from 'antd';
import { CheckOutlined, UserOutlined, PhoneOutlined, HomeOutlined, FolderAddOutlined } from '@ant-design/icons';


import useLocalidad from "./../../../../../../hooks/HookLocalidades";
import {useSchools} from "./../../../../../../hooks/useSchools";
import { useLogin } from '../hooks/HookLogin';

import PersonalInfoStep from './PersonalInfoStep';
import ContactInfoStep from './ContactInfoStep';
import AddressStep from './AddressStep';
import ConfirmationStep from './ConfirmationStep';
import ExtraInfoStep from './ExtraInfoStep';

const { Step } = Steps;

const RegistrationForm = ({ onClose }) => {
    const { catLocalidades, getLocalidadesByCP } = useLocalidad();
    const { schoolsList, fetchSchools } = useSchools();

    const [stepIndex, setStepIndex] = useState(0);
    const [loadingForm, setLoadingForm] = useState(false);
    const [cpValidated, setCpValidated] = useState(false);
    const [Egresado, setEgresado] = useState({});
    const { onRegisterEgresado, onRegisterEgresadoMatriculaAntigua } = useLogin();
    const [form] = Form.useForm();

    const goNext = async () => {
        setLoadingForm(true);
        try { 
            await form.validateFields();
            setStepIndex(stepIndex + 1);
        } catch {
            message.error("Completa los campos correctamente");
        }
        setLoadingForm(false);
    };

    const goPrev = () => setStepIndex(stepIndex - 1);

    const handleFinish = async () => {
        setLoadingForm(true);
        const values = form.getFieldsValue(true);
        try {
            // Aquí se llama a la función de registro para el egresado
            const response =  !Egresado.matricula_antigua ? await onRegisterEgresado(values) : await onRegisterEgresadoMatriculaAntigua(values);
            if (response.success) {
                form.resetFields();
                setStepIndex(0);
                setEgresado(null);
                setLoadingForm(false);
                onClose();
            }
        } catch (error) {
            message.error('Error al registrar el egresado');
        } finally {
            setLoadingForm(false);
        }
    };

    const steps = [
        {
            title: 'Verificar',
            icon: <UserOutlined />,
            content:
                <PersonalInfoStep
                    form={form}
                    goNext={goNext}
                    Egresado={Egresado}
                    setEgresado={setEgresado}
                    onClose={onClose}
                />
        },
        Egresado?.matricula_antigua && {
            title: 'Datos para verificación',
            icon: <FolderAddOutlined />,
            content:
                <ExtraInfoStep
                    form={form}
                    schools={schoolsList} 
                    fetchSchools={fetchSchools}
                    goNext={goNext}
                    goPrev={goPrev}
                />
        },
        {
            title: 'Contacto',
            icon: <PhoneOutlined />,
            content:
                <ContactInfoStep
                    Egresado={Egresado}
                    goNext={goNext}
                    goPrev={goPrev}
                />
        },
        {
            title: 'Dirección',
            icon: <HomeOutlined />,
            content:
                <AddressStep
                    form={form}
                    goNext={goNext}
                    goPrev={goPrev}
                    cpValidated={cpValidated}
                    setCpValidated={setCpValidated}
                    catLocalidades={catLocalidades}
                    getLocalidadesByCP={getLocalidadesByCP}
                />
        },
        {
            title: 'Confirmar',
            icon: <CheckOutlined />,
            content:
                <ConfirmationStep
                    goPrev={goPrev}
                    form={form}
                    catLocalidades={catLocalidades}
                    loading={loadingForm} />
        }
    ].filter(Boolean);

    return (
        <>
            <Row justify="center" gutter={[16, 16]}>
                <Col xs={24} sm={20}>
                    <Steps current={stepIndex} size="small">
                        {steps.map(item => (
                            <Step key={item.title} icon={item.icon} title={item.title} />
                        ))}
                    </Steps>
                </Col>

                <Divider>{Egresado?.nombre_completo ? `BIENVENID@: ${Egresado?.nombre_completo}` : 'BIENVENIDOS AL SISTEMA DE EGRESADOS'}</Divider>
                <Col span={22}>
                    <Form
                        form={form}
                        layout="vertical"
                        onFinish={handleFinish}
                    >
                        {steps[stepIndex].content}
                    </Form>
                </Col>
            </Row>
        </>
    );
};

export default RegistrationForm;
